module.exports = __webpack_public_path__ + "static/media/police.d0289dc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/police.png
// module id = 194
// module chunks = 0